<template>
    <ListDetailLayout :store="regulationsStore" index-route-name="admin.regulations"
        create-permissions="create:regulations"
        @on-create="$router.push({ name: 'admin.regulations.regulation', params: { regulation: 'NEW' } })"
        @on-paginate="(page) => useOnPaginate(page, () => refreshRegulations(false), params)"
        @on-search="(page) => useOnSearch(page, () => refreshRegulations(false), params)"
        create-button-admin-page="create-regulation-btn" 
        search-admin-page="search-regulation-admin-page">
        <template #list>
            <li v-for="regulation in regulationsStore.getRegulations" :key="regulation.id">
                <router-link :to="{ name: 'admin.regulations.regulation', params: { regulation: regulation.id } }"
                    v-slot="{ isActive }">
                    <div
                        :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

                        <div class="min-w-0">
                            <div class="flex items-start gap-x-3">
                                <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{
                                    regulation.name }}</p>
                            </div>
                            <div
                                class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
                                <p class="whitespace-nowrap">
                                    {{ regulation.description }}
                                </p>
                            </div>
                        </div>

                    </div>
                </router-link>
            </li>
        </template>

        <template #detail>
            <router-view v-if="$route.params.regulation" @on-save="refreshRegulations(false)"
                @on-delete="refreshRegulations(false)"></router-view>
        </template>

    </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useRegulationsStore } from "@/stores/regulations.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
    name: "RegulationsIndex",
    data() {
        return {
            params: {}
        }
    },
    methods: {
        useOnSearch,
        useOnPaginate,
        refreshRegulations(silent = true) {
            try {
                return this.regulationsStore.indexRegulations(this.params, silent);
            } catch (e) {
                console.log(e);
            }
        },
    },
    components: { Container, ListDetailLayout },
    computed: {
        ...mapStores(useRegulationsStore)
    },
    async mounted() {
        await this.refreshRegulations()
    }
}
</script>
